import { render, staticRenderFns } from "./PoweredByLanding.vue?vue&type=template&id=7560132b&scoped=true"
import script from "./PoweredByLanding.vue?vue&type=script&lang=js"
export * from "./PoweredByLanding.vue?vue&type=script&lang=js"
import style0 from "./PoweredByLanding.vue?vue&type=style&index=0&id=7560132b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7560132b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7560132b')) {
      api.createRecord('7560132b', component.options)
    } else {
      api.reload('7560132b', component.options)
    }
    module.hot.accept("./PoweredByLanding.vue?vue&type=template&id=7560132b&scoped=true", function () {
      api.rerender('7560132b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/PoweredBy/PoweredByLanding.vue"
export default component.exports